var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mx-2 mb-1 elevation-5 rounded-lg"},[_c('ProfilDaerahMainMap')],1),(true)?_c('ProfilDaerahMainTable',{attrs:{"jenis":_vm.jenis}}):_vm._e(),_c('InfoDialog',{ref:"infoDialog",attrs:{"infoDialogMessage":_vm.infoDialogMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }